<template>
<span v-if="showAddLayoutTemplate()">
  <view-details ref="viewTemplateDetailsDialog" :show-grid-icon="false" :day-of-week="dayOfWeek" :code="new Number(form.code)" :name="form.name" :layout-template-id="layoutTemplateId" />
  <el-button id="btn-add-layouttemplate" type="success" plain @click="dialogVisible = true" size="mini">{{ $t('layoutTemplate.addLayout') }}</el-button>
  <el-dialog
    :close-on-click-modal="false"
    v-on:open="handleOpen"
    :title="$t('layoutTemplate.addLayout')"
    :visible.sync="dialogVisible"
    width="65%"
    class="dialog-with-cols"
    :before-close="handleClose"
  >
  <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
    <el-row>
      <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
        <el-form-item :label="$t('layoutTemplate.warehouse')" prop="warehouse">
          <el-input
            v-model="form.warehouse"
            disabled
            class="inline-input"
            id="form-warehouse"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
        <el-form-item :label="$t('layoutTemplate.dayOfWeek')" prop="number">
          <el-select v-model="form.day" id="form-day" class="inline-input" size="mini">
            <el-option
              v-for="item in daysOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
        <el-form-item :label="$t('layoutTemplate.code')" prop="code">
          <el-input
            v-model="form.code"
            v-numeric-validation
            maxlength="9"
            class="inline-input"
            id="form-code"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
        <el-form-item :label="$t('layoutTemplate.name')" prop="name">
          <el-input
            v-model="form.name"
            v-alphanumeric-validation
            maxlength="50"
            class="inline-input"
            id="form-name"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-save-button" @click="submitForm()" size="mini">{{ $t('layoutTemplate.addLayout') }}</el-button>
      <el-button id="form-cancel-button" @click="dialogVisible = false" size="mini">{{ $t('layoutTemplate.cancel') }}</el-button>
  </div>
  </el-dialog>
</span>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import ViewDetails from '@/views/warehouse/layout/template/components/ViewDetails';

export default {
  components: { ViewDetails },
  computed: {
    ...mapGetters([
      'layoutTemplate',
      'user'
    ]),
    daysOptions() {
      return constants.DAYS_OPTIONS.filter(option => option.value != null);
    },
    dayOfWeek() {
      return constants.DAYS_OPTIONS.find(option => option.value === this.form.day).label;
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        warehouse: '',
        day: '0',
        code: null,
        name: null
      },
      layoutTemplateId: 0,
      formRules: {
        code: [
          { required: true, message: this.$t('layoutTemplate.error.codeRequired'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('layoutTemplate.error.nameRequired'), trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose(done) {
      done();
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('layoutTemplate/save', this.form)
            .then((response) => {
              this.layoutTemplateId = response.data.layoutId;
              if (this.$refs && this.$refs.viewTemplateDetailsDialog) {
                this.dialogVisible = false;
                this.$nextTick(async () => {
                  await this.$refs.viewTemplateDetailsDialog.handleOpenDialog();
                  this.$nextTick(() => {
                    this.$message.success(response.message);
                  });
                });
              } else {
                this.$store.dispatch('layoutTemplate/search', {});
                this.resetForm();
              }
            })
            .finally(() => {
              loading.close();
            });
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.day = '0';
      this.form.code = null;
      this.form.name = null;
      this.form.warehouse = this.user.warehouseCode;
    },
    showAddLayoutTemplate() {
      return this.$can(this.permissions.WAREHOUSE.EDIT_LAYOUT_TEMPLATES);
    }
  }
};
</script>
